import LoginSplash from 'assets/branding/login-splash.jpg';
import { ThemedImage } from 'assets/icon/KCFLogo';
import { KCFStylesProvider } from 'contexts/ThemeContext';
import { MediaQueries } from 'custom_hooks/useWindowSize';
import { ReactNode } from 'react';
import styled from 'styled-components';
import { tokens } from 'styles/tokens';

const GridContainer = styled.div`
    display: flex;
    flex-direction: row;
    height: 100%;
    width: 100%;

    @media ${MediaQueries.mediumAndDown} {
        flex-direction: column-reverse;
    }
`;

const SplashContainer = styled.div`
    background-image: url('${LoginSplash}');
    background-size: cover;
    width: 100%;
    height: 100vh;
    background-position: 70% 20%;

    @media ${MediaQueries.mediumAndUp} {
        z-index: -1;
        position: fixed;
        top: 0;
        right: 0;
    }

    @media ${MediaQueries.mediumAndDown} {
        height: 30rem;
        background-position: 100% 30%;
    }

    @media ${MediaQueries.smallAndDown} {
        background-position: center center;
    }
`;

const LoginScreenContainer = styled.div`
    padding: 2rem;
    background: ${tokens.background.paperElevation2};
    display: flex;
    overflow-y: auto;

    @media ${MediaQueries.mediumAndDown} {
        flex-grow: 1;
    }

    @media ${MediaQueries.mediumAndUp} {
        align-items: center;
        padding: 4rem;
        width: 30%;
        min-width: 45rem;
    }
`;

const LoginItems = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
`;

const LogoContainer = styled.div`
    display: flex;
    height: 6rem;
    gap: 1rem;
    align-items: center;
    margin-bottom: 2rem;
    // margin-top: -3rem;

    @media ${MediaQueries.mediumAndDown} {
        margin-top: 0;
    }
`;

const Separator = styled.div`
    height: 100%;
    border-right: 1px solid ${tokens.input.border};
`;

export const TermsOfUseScreen = styled.div`
    box-sizing: border-box;
    max-width: 65rem;
    width: 100%;
    padding: 2rem;
    margin-top: 2rem;
    background: ${tokens.background.paperElevation2};
    border-radius: 2px;
    box-shadow: ${tokens.elevation['100']};
    @media (min-width: 320px) {
        margin-left: 1rem;
        margin-right: 1rem;
    }
    @media ${MediaQueries.smallAndUp} {
        padding: 2rem;
        margin-top: 2rem;
    }
`;

export type LoginScreenProps = Readonly<{
    children: ReactNode;
}>;

export function LoginScreen({ children }: LoginScreenProps) {
    return (
        <KCFStylesProvider>
            <GridContainer>
                <LoginScreenContainer>
                    <LoginItems>
                        <LogoContainer>
                            <ThemedImage
                                icon={'kcf-logo'}
                                alt="KCF Technologies"
                                style={{ height: '5.4rem' }}
                            />
                            <Separator />
                            <ThemedImage
                                icon={'smart-diagnostics'}
                                alt="SMARTdiagnostics"
                                style={{ height: '6.5rem' }}
                            />
                        </LogoContainer>
                        {children}
                    </LoginItems>
                </LoginScreenContainer>
                <SplashContainer />
            </GridContainer>
        </KCFStylesProvider>
    );
}
